export const maxFileSize = 1048576;
